module.exports = __webpack_public_path__ + "static/media/no-image-available.1aa5e502.png";